// Components
import { Button, Typography } from "@mui/material";

// Icons
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

type NavButtonProps = {
	direction: "prev" | "next";
	disabled?: boolean;
	onClick: () => void;
};
export default function NavButton(props: Readonly<NavButtonProps>) {
	return (
		<Button
			variant={"text"}
			onClick={props.onClick}
			disableRipple
			disableElevation
			disabled={props.disabled}
			startIcon={
				props.direction === "prev" ? (
					<ArrowBackIosRoundedIcon style={{ color: props.disabled ? "" : "#6c6c6c", fontSize: "17px" }} />
				) : null
			}
			endIcon={
				props.direction === "next" ? (
					<ArrowForwardIosIcon style={{ color: props.disabled ? "" : "#6c6c6c", fontSize: "17px" }} />
				) : null
			}
		>
			<Typography className={`!font-sans !text-[17px] ${props.disabled ? "" : "text-[#666666]"} capitalize`}>
				{props.direction === "prev" ? "Prev." : "Next"}
			</Typography>
		</Button>
	);
}
